import React from "react";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import { statement } from "../../locales/en";
import StatementForm from "./StatementForm";

function Statements() {
  return (
    <div>
      <HeaderDashboard />
      <div className="home-main-section">
        <div className="container">
          <div className="home-title">
            <h1>{statement?.main_title}</h1>
          </div>
          <StatementForm />
        </div>
      </div>
    </div>
  );
}

export default Statements;
